import { render, staticRenderFns } from "./addLinkManagement.vue?vue&type=template&id=5d1a63b7&"
import script from "./addLinkManagement.vue?vue&type=script&lang=js&"
export * from "./addLinkManagement.vue?vue&type=script&lang=js&"
import style0 from "./addLinkManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports